import React, { Component } from 'react'
// Local imports
import Content from './Layouts/Content'
import Topbar from './Layouts/Topbar'
import { UserContext } from './context/UserProvider'

function AppContainer(props) {
	const context = React.useContext(UserContext)

	let { showBars, user } = props
	return (
		<div id="master_container" className="tw-pt-16">
			{showBars && <Topbar user={user} />}
			<Content showBars={showBars} user={user} />
		</div>
	)
}
export default AppContainer
